export default "__VITE_ASSET__D2eBuI1g__";